// extracted by mini-css-extract-plugin
module.exports = {"Container":"CenterContainer_Container__1IfWN"};